// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2VZ3X","footer":"Form_footer__MZ4__"};